import React from "react";
import styled from "styled-components";
import { navigateTo } from "gatsby-link";

import Button from "../components/UI/Button";
import baseStyles from "../styles/baseStyles";
import JobCardList from "../components/Jobs/JobCardList";
import EventCardList from "../components/Events/EventCardList";
import Carousel from "../components/Carousel";

import { MapSection } from "../components/MapSection";

const Container = styled.main`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const HeroContent = styled.div`
  max-width: 64rem;
  text-align: center;
  position: relative;
  background: transparent;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 64em) {
    padding: 0 2rem;
  }
  @media screen and (max-width: 20em) {
    padding: 0 1rem;
  }
  @media screen and (max-width: 425px) {
    align-items: stretch;
  }
`;

const Display = styled.h1`
  text-transform: uppercase;
  font-family: Poppins;
  letter-spacing: 0.1em;
  line-height: 1;
  font-size: 3rem;
  margin: 0;
  @media screen and (max-width: 425px) {
    font-size: 2.25rem;
  }
`;

const DisplayWhite = styled(Display)`
  color: ${baseStyles.color.white.o100};
`;

const Title = styled.h2`
  text-transform: uppercase;
  font-family: Poppins;
  letter-spacing: 0.1em;
  font-size: 2.25rem;
  margin-bottom: 1rem;
`;

const TitleDark = Title.extend`
  color: ${baseStyles.color.darkGray};
  text-align: center;
`;

const Subtitle = styled.h4`
  font-family: Lato;
  letter-spacing: 0.1em;
  font-size: 1rem;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 400;
`;

const SubtitleWhite = styled(Subtitle)`
  color: ${baseStyles.color.white.o100};
`;

const Section = styled.section`
  max-width: 64rem;
  width: 100%;
  margin: auto;
  margin-top: 6rem;
  text-align: center;
  @media screen and (max-width: 64em) {
    width: calc(100vw - 4rem);
    margin: auto;
  }
  @media screen and (max-width: 20em) {
    width: calc(100vw - 2rem);
  }
`;

const IndexPage = ({ data }) => (
  <Container>
    <Carousel images={data.heroImages.edges.map(e => e.node)}>
      <HeroContent>
        <DisplayWhite>Move To Nordics</DisplayWhite>
        <SubtitleWhite>
          Your portal to the best tech ecosystem in the world.
        </SubtitleWhite>
      </HeroContent>
    </Carousel>
    <MapSection countries={data.countries.edges.map(e => e.node)} />
    <Section>
      <TitleDark>Tech Jobs</TitleDark>
      <JobCardList jobs={data.jobs.edges.map(e => e.node)} />
      <Button
        onClick={() => navigateTo("/jobs")}
        style={{ alignSelf: "center", marginTop: "2rem" }}
        primary
      >
        See more jobs
      </Button>
    </Section>
    <Section>
      <TitleDark>Events in the Nordics</TitleDark>
      <EventCardList
        events={data.events.edges
          .filter(({ node }) => new Date(node.date) > new Date())
          .slice(0, 2)}
      />
      <Button
        onClick={() => navigateTo("/events")}
        style={{ alignSelf: "center", marginTop: "2rem" }}
        primary
      >
        See all events
      </Button>
    </Section>
  </Container>
);

export const query = graphql`
  query Homepage {
    heroImages: allHomepageImage {
      edges {
        node {
          id
          imageDescription
          image {
            handle
            width
            height
          }
        }
      }
    }
    jobs: allJob(sort: { fields: [postedAt], order: DESC }, limit: 5) {
      edges {
        node {
          id
          title
          link
          location
          country
          positionType
          postedAt
          role
          company {
            name
            logo {
              url
              handle
              width
              height
            }
          }
        }
      }
    }
    events: allEvent(sort: { fields: [date], order: ASC }) {
      edges {
        node {
          id
          title
          description
          date
          locationName
          link
          image {
            handle
            width
            height
          }
        }
      }
    }
    countries: allCountry {
      edges {
        node {
          id
          name
          description
          icon {
            url
            handle
          }
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js